let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("glsNq")).then(() => parcelRequire('bJeeF'));